import JSZip from "jszip";
function opDownloadFile(fileUrl, fileName) {
  return new Promise((resolve) => {
    if (!fileName) {
      fileName = fileUrl.split("/").pop() || "download";
    }
    const xhr = new XMLHttpRequest();
    xhr.open("GET", fileUrl, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          const blob = new Blob([xhr.response]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          resolve({ status: true, message: "\u4E0B\u8F7D\u6210\u529F" });
        } catch (error) {
          resolve({ status: false, message: `\u4E0B\u8F7D\u8FC7\u7A0B\u51FA\u9519: ${error}` });
        }
      } else {
        resolve({ status: false, message: `\u4E0B\u8F7D\u5931\u8D25\uFF0C\u72B6\u6001\u7801: ${xhr.status}` });
      }
    };
    xhr.onerror = () => {
      resolve({ status: false, message: "\u7F51\u7EDC\u9519\u8BEF\u6216\u6587\u4EF6\u4E0D\u5B58\u5728" });
    };
    xhr.send();
  });
}
async function opBatchDownloadFiles(files, zipFileName = "download.zip") {
  const zip = new JSZip();
  for (const file of files) {
    try {
      const response = await fetch(file.url);
      if (!response.ok) {
        throw new Error(`\u4E0B\u8F7D\u5931\u8D25\uFF0C\u72B6\u6001\u7801: ${response.status}`);
      }
      const blob = await response.blob();
      const fileName = file.fileName || file.url.split("/").pop() || "unknown";
      zip.file(fileName, blob);
    } catch (error) {
      return { status: false, message: `\u6587\u4EF6\u4E0B\u8F7D\u5931\u8D25: ${file.url}, \u9519\u8BEF: ${error.message}` };
    }
  }
  try {
    const zipBlob = await zip.generateAsync({ type: "blob" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(zipBlob);
    link.href = url;
    link.download = zipFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return { status: true, message: "\u538B\u7F29\u5305\u4E0B\u8F7D\u6210\u529F" };
  } catch (error) {
    return { status: false, message: `\u538B\u7F29\u5305\u751F\u6210\u5931\u8D25: ${error.message}` };
  }
}
export { opBatchDownloadFiles, opDownloadFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/down.js